import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, AdhocMaintenance } from '@/models/AdhocMaintenance.model';

// Inital state
const state: AdhocMaintenance = {
  adhocMaintenance: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, AdhocMaintenance> = {
  adhocMaintenance: (state) => state.adhocMaintenance,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, AdhocMaintenance> = {
  setAdhocMaintenanceItems(state, { adhocMaintenance }) {
    state.adhocMaintenance = adhocMaintenance;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, AdhocMaintenance, Mutations, Getters> = {
  setAdhocMaintenanceItems({ commit }, payload) {
    commit('setAdhocMaintenanceItems', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<AdhocMaintenance, Getters, Mutations, Actions>('AdhocMaintenanceModule');

export const AdhocMaintenanceModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
